<template>
  <div class="card-ticket-new">
    <!-- <div class="card-ticketLeft"> -->
    <div class="card-ticket-left">
      <!-- <img src=""
           alt=""> -->
      <div class="card-ticket-bg">
        <img src="../../assets/images/card-ticket/du.png" alt="">
        <!--  -->
        <p class="card-ticket-tex card-ticket-title" :title="formInline.ticketName">{{formInline.ticketName}}</p>
        <p class="card-ticket-tex card-ticket-symk" ref="syms1"></p>
        <p class="card-ticket-tex card-ticket-date" v-if="radio == 1">
          <span>{{formInline.startTimeStr}}</span> 至
          <span>{{formInline.endTimeStr}}</span>
        </p>
        <p class="card-ticket-tex card-ticket-date" v-if="radio == 0">领券当日起
          <span> {{formInline.receiveLimitDay}} </span>天内可用</p>
        <p class="card-ticket-tex card-ticket-date" v-if="radio == 2">长期有效</p>
        <img src="../../assets/images/card-ticket/code.png" alt="" class="card-ticket-code">
        <div class="card-ticket-tex card-ticket-tips">
          <ul>
            <li>
              <p class="yhtitle">
                <i class="card-ticket-icon"></i>优惠内容
              </p>
              <p class="yhContent" ref="yhtitle">
                {{formInline.discountContent}}
              </p>
            </li>
            <li>
              <p class="yhtitle">
                <i class="card-ticket-icon"></i>使用说明
              </p>
              <p class="yhContent" ref="yhContent">
                {{formInline.useExplain}}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- </div> -->

    <div class="card-ticket-right setting-content">
      <p class="card-info">基本信息</p>
      <el-form :inline="true" :rules="rules" :model="formInline" label-width="95px" class="card-form">
        <el-form-item label="卡券类型" prop="ticketType">
          <el-select clearable v-model="formInline.ticketType" placeholder="请选择卡券类型" :disabled="true">
            <el-option v-for="(item,index) in cardTypeOptions" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡券名称" prop="ticketName">
          <el-input placeholder="请输入卡券名称" clearable v-model="formInline.ticketName" show-word-limit
            :maxlength="ticketNameLength" @input="descInput('name')">
          </el-input>
          <span class="cardNameYz">{{ticketName}}/{{ticketNameLength}}</span>
        </el-form-item>
        <el-form-item label="有效期" prop="isPeriodValidity">
          <div class="timeBox">
            <el-radio-group v-model="radio" @change="radioChange">
              <!--  -->
              <div class="card-trcekt-date">
                <el-radio :label="1">
                  <el-date-picker v-model="formInline.startTimeStr" type="datetime" placeholder="开始时间"
                    value-format="yyyy-MM-dd HH:mm">
                  </el-date-picker>
                  至
                  <el-date-picker v-model="formInline.endTimeStr" type="datetime" placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm">
                  </el-date-picker>

                </el-radio>
              </div>
              <div class="card-trcekt-yxq">
                <el-radio :label="0">
                  领券当日起
                  <el-input v-model="formInline.receiveLimitDay" :max="999">
                  </el-input>
                  天内可用
                </el-radio>
              </div>
              <div class="card-trcekt-yxq">
                <el-radio :label="2">
                  长期有效
                </el-radio>
              </div>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="优惠内容" prop="discountContent"
          v-if="formInline.ticketType == 1 || formInline.ticketType == 2">
          <el-input type="textarea" placeholder="200字以内，建议写明卡券对应的服务内容" v-model="formdiscountContent"
            :autosize="{ minRows: 3, maxRows: 6 }" maxlength="200" @input="descInput('conent')">
          </el-input>
          <span class="textareaYz">{{discountContent}}/200</span>
        </el-form-item>
        <el-form-item label="可兑换产品范围" prop="productId" style="border:none;text-align:left;width: 100%;"
          v-if="formInline.ticketType != 2">
          <el-radio v-model="productionRadio" label="1">全部产品</el-radio>
          <el-radio v-model="productionRadio" label="2">指定产品</el-radio>
          <div v-show="productionRadio === '2'">
            <el-button type="text" @click="handleOpenDialog">选择产品</el-button>
          </div>
          <prize-product-dialog :dialog-visible="productDialog" @handleProductClose="handleCloseDialog"
            @handleChoosedProduct="handleChoosedProduct"></prize-product-dialog>
          <prize-product-table :productionRadio="productionRadio" :choosed-product-list="choosedProductList"
            @handleProductList="handleProductList"></prize-product-table>

        </el-form-item>
        <el-form-item label="代金券类型" prop="productId" v-if="formInline.ticketType == 3">
          <el-radio-group v-model="formInline.cashCouponType" @change="cashCouponChange">
            <el-radio :label="1">随机金额代金券</el-radio>
            <el-radio :label="2">满减券</el-radio>
            <el-radio :label="3">折扣券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠内容" prop="discount" v-if="formInline.cashCouponType !== 1">
          <div class="faceValue-box">
            <span v-if="formInline.cashCouponType == 2">面值</span>
            <span v-else>打</span>
            <el-input v-model="formInline.discount" @change="discountChange">
            </el-input>
            <span v-if="formInline.cashCouponType == 2">元</span>
            <span v-else>折</span>
          </div>
        </el-form-item>
        <el-form-item label="使用门槛" prop="threshold"
          v-if="formInline.cashCouponType == 2 || formInline.cashCouponType == 3">
          <div class="timeBox faceValue-box">
            <el-radio-group v-model="formInline.threshold">
              <el-radio :label="1">无使用门槛</el-radio>
              <el-radio :label="2">
                <span>满</span>
                <el-input v-model="formInline.usingThreshold" @change="thresholdChange"></el-input>
                <span>元使用</span>
              </el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="优惠内容" v-if="formInline.ticketType == 3 && formInline.cashCouponType == 1" required>
          <div class="cashCoupon_style">
            <el-col :span="5">
              <span>范围内随机</span>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="discountStart">
                <el-input type="number" v-model="discountStart">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div style="text-align: center;">至</div>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="discountEnd">
                <el-input type="number" v-model="discountEnd">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div style="text-align: center;">元</div>
            </el-col>
            <el-col :span="2">
              <i class="el-icon-question" @mouseenter="enter()" @mouseleave="leave()"></i>
            </el-col>
            <div class="cashCoupon_ts" id="cashCoupon_ts">前后金额一致则为固定金额</div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="核销操作"
                      prop="">
          <div class="card-hxSelect"
               v-for="(item, index) in hxList"
               :key="index">
            <el-select v-model="item.activityType"
                       placeholder="请选择受众"
                       @change="szChange">
              <el-option v-for="item in szOptions"
                         :key="item.modelId"
                         :label="item.modelName"
                         :value="item.modelId">
              </el-option>
            </el-select>
            <el-select v-model="item.qzType"
                       placeholder="请选择群组">
              <el-option v-for="items in qzOptions"
                         :key="items.groupId"
                         :label="items.groupName"
                         :value="items.groupId">
              </el-option>
            </el-select>
            <div class="remove-btn-quota"
                 style="float: right;margin: 0 20px 0 10px;cursor: pointer"
                 @click="removeDimensionItem(item, index)">
              <i class="el-icon-error"
                 title="删除当前条件"
                 style="color: #ccc;font-size: 15px"></i>
            </div>
          </div>
          <div class="card-sz"
               @click="addAnalyseDimension">
            <i class="el-icon-circle-plus"
               style="color: #1890ff;"></i>
            <div class="op-link"
                 style="margin: 0;font-size: 14px">增加受众</div>
          </div>
        </el-form-item> -->
        <el-form-item label="核销操作" prop="">
          <el-select v-model="formInline.relateAudienceObject.modelId" placeholder="请选择受众" clearable @change="szChange">
            <el-option v-for="item in szOptions" :key="item.modelId" :label="item.modelName" :value="item.modelId">
            </el-option>
          </el-select>
          <div style="max-height: 90px; overflow-y:auto ;margin-top:15px;">
            <!-- @click.native="szChange"  :remote-method=""-->
            <el-select filterable remote multiple v-model="qzValue" placeholder="请选择群组">
              <el-option v-for="items in qzOptions" :key="items.groupId" :label="items.groupName"
                :value="items.groupId">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="使用说明" prop="useExplain">
          <el-input type="textarea" placeholder="500字以内" v-model="formInlineuseExplain" maxlength="500"
            :autosize="{ minRows: 3, maxRows: 6 }" @input="descInput('explain')">
          </el-input>
          <span class="textareaYz">{{remnant}}/500</span>
        </el-form-item>
        <el-form-item>
          <div class="card-submit">
            <el-button type="primary" @click="editTemplate">保存</el-button>
          </div>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { cardList, getModelList, getModelGroupList, sbmitTemplate, editTemplate, getProductList } from '@/api/cardTicket.js'
import { CARD_TYPE, PRODUCT_RADIO } from './constant.js'
import prizeProductDialog from './components/prize-product-dialog.vue'
import prizeProductTable from './components/prize-product-table.vue'
import { mapMutations } from 'vuex'
export default {
  data () {
    var checkStar = (rule, value, callback) => {
      if (String(value).indexOf('.') > -1) {
        if (value.toString().split('.')[1].length > 2) {
          callback(new Error('优惠券面值必须是两位小数！'))
        } else if (value > 10000) {
          callback(new Error('优惠券面值不得超过10000元!'))
        }
      } else if (value <= 0) {
        callback(new Error('优惠券面值必须大于等于 0.01 元!'))
      } else if (value > 10000) {
        callback(new Error('优惠券面值不得超过10000元!'))
      } else {
        callback()
      }
    }
    var discount = (rule, value, callback) => {
      if (value) {
        if (this.formInline.cashCouponType == 3) {
          if (!/^\d+(\.\d{1,1})?$/.test(value)) {
            callback(new Error('最多输入一位小数'))
          } else if (value > 10 || value < 0) {
            callback(new Error('折扣券优惠内容必须介于0到10之间！'))
          } else {
            callback()
          }
        }
      } else {
        callback(new Error('请填写优惠内容'))
      }
    }
    return {
      dataList: {
        'ticketName': '',
        'id': '',
        'page': {
          'limit': 10,//每页显示的条数
          'page': 1,//当前页数
        }
      },
      ticketNameLength: 30, // 卡券名称长度
      productionRadio: null, //  全部产品 ：1  指定产品：2
      productDialog: false, //选择产品的弹窗
      choosedProductList: [],// 弹窗中选择的产品列表
      formInline: {
        id: '',
        ticketType: '',
        ticketName: '',
        isPeriodValidity: '',
        startTimeStr: '',
        endTimeStr: '',
        receiveLimitDay: '',
        discountContent: '',
        discountStart: '',
        discountEnd: '',
        useExplain: '',
        relateAudienceObject: {
          modelId: '',
          groupIds: []
        },
        commoditys: [{
          code: '',
          name: ''
        }],
        cashCouponType: 1,//代金券类型
        faceValue: '',//面值
        threshold: 1,//使用门槛
        discount: 0,//打折数
        usingThreshold: ''
      },
      productId: '',
      productRelationArray: [],
      clickRelationArray: [],
      discountStart: '',
      discountEnd: '',
      formdiscountContent: '',
      formInlineuseExplain: '',
      activityTypeOptions: {},
      cardType: '',
      cardTypeOptions: [
        {
          value: 1,
          name: '实物兑换券'
        },
        {
          value: 2,
          name: '活动券'
        },
        {
          value: 3,
          name: '代金券'
        },
      ],
      szNames: '',
      szOptions: [],//受众列表
      qzValue: [],
      qzOptions: [],//群组列表
      qzParams: {
        modelId: '',
        groupIds: []
      },
      rules: {
        ticketType: [{
          required: true,
          message: '请选择卡券类型',
          trigger: 'blur'
        }],
        ticketName: [{
          required: true,
          message: '请输入卡券名称',
          trigger: 'blur'
        }],
        isPeriodValidity: [{
          required: true,
          message: '请设定有效期',
          trigger: 'blur'
        }],
        discountContent: [{
          required: true,
          message: '请输入优惠内容',
          trigger: 'blur'
        }],
        useExplain: [{
          required: true,
          message: '请输入使用说明',
          trigger: 'blur'
        }],
        discountStart: [{
          required: true,
          validator: checkStar,
          trigger: 'blur'
        }],
        discountEnd: [{
          required: true,
          validator: checkStar,
          trigger: 'blur'
        }],
        discount: [{
          validator: discount,
          trigger: 'blur',
          required: true
        }],
        fullReduction: [{
          validator: discount,
          trigger: 'blur',
          required: true
        }],
        faceValue: [{
          validator: discount,
          trigger: 'blur',
          required: true
        }],
        threshold: [{
          required: true,
          message: '请选择使用门槛',
          trigger: 'blur'
        }],
      },
      ticketName: '',
      discountContent: 0,
      remnant: 0,
      validityDate: '',
      radio: 1,
      input: '',
      analyseQuotaData: [
        {
          analyseQuota: ['customer', 'peopleNum', 'sum']
        }
      ],
      hxList: [{
        activityType: '',
        qzType: ''
      }],
      commoditys: [],
      qzarr: []
    }
  },
  components: {
    prizeProductDialog,
    prizeProductTable
  },
  watch: {
    formInlineuseExplain (newVal, oldVal) {
      this.formInline.useExplain = newVal
      this.$refs.yhContent.innerHTML = newVal.replace(/\n/g, '<br>')
    },
    formdiscountContent (newVal, oldVal) {
      this.formInline.discountContent = newVal
      if (this.formInline.ticketType == 1 || this.formInline.ticketType == 2) {
        this.$refs.yhtitle.innerHTML = newVal.replace(/\n/g, '<br>')
      }
    },
    discountStart (newVal, oldVal) {
      this.formInline.discountStart = newVal
      if (this.formInline.ticketType === 3) {
        if (newVal == this.discountEnd) {
          if (this.formInline.cashCouponType === 1) {
            this.$refs.yhtitle.innerHTML = this.discountStart + '元代金券'
          }
        } else {
          this.$refs.yhtitle.innerHTML = this.formInline.discountStart + '-' + this.formInline.discountEnd + '元代金券'
        }
      }

    },
    discountEnd (newVal, oldVal) {
      this.formInline.discountEnd = newVal
      if (this.formInline.ticketType === 3) {
        if (newVal == this.discountStart) {
          if (this.formInline.cashCouponType === 1) {
            this.$refs.yhtitle.innerHTML = this.discountEnd + '元代金券'
          }
        } else {
          this.$refs.yhtitle.innerHTML = this.formInline.discountStart + '-' + this.formInline.discountEnd + '元代金券'
        }
      }

    },
    // 监听面值
    'formInline.faceValue' (newVal, oldVal) {
      if (this.formInline.threshold == 1) {
        this.$refs.yhtitle.innerHTML = this.formInline.faceValue + '元代金券，无门槛使用'
      } else {
        this.$refs.yhtitle.innerHTML = this.formInline.faceValue + '元代金券，满' + this.formInline.usingThreshold + '元使用'
      }
    },
    // 监听使用门槛
    'formInline.threshold' (newVal, oldVal) {
      if (newVal == 1) {
        if (this.formInline.cashCouponType === 2) {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '元满减券，无使用门槛'
          this.$refs.syms1.innerHTML = '无使用门槛'
        }
      } else {
        if (this.formInline.cashCouponType === 2) {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '元满减券，满' + this.formInline.usingThreshold + '元使用'
          this.$refs.syms1.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
        }
      }
    },
    // 监听使用门槛的钱数
    'formInline.usingThreshold' (newVal, oldVal) {
      if (this.formInline.cashCouponType == 2) {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '元满减券，无使用门槛'
          this.$refs.syms1.innerHTML = '无使用门槛'
        } else {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '元满减券，满' + this.formInline.usingThreshold + '元使用'
          this.$refs.syms1.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
        }
      } else if (this.formInline.cashCouponType == 3) {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '折代金券，无使用门槛'
          this.$refs.syms1.innerHTML = '无使用门槛'
        } else {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '折代金券，满' + this.formInline.usingThreshold + '元使用'
          this.$refs.syms1.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
        }

      }
    },
    // 监听打折数
    'formInline.discount' (newVal, oldVal) {
      console.log(this.formInline.threshold, 'this.formInline.threshold ===')
      if (this.formInline.cashCouponType == 2 && (this.formInline.ticketType != 1 && this.formInline.ticketType != 2)) {
        if (this.formInline.threshold == 1) {
          if (this.formInline.cashCouponType === 2) {
            this.$refs.yhtitle.innerHTML = this.formInline.discount + '元满减券，无门槛使用'
            this.$refs.syms1.innerHTML = '无使用门槛'
          }
        } else {
          if (this.formInline.ticketType != 1 && this.formInline.ticketType != 2) {
            if (this.formInline.cashCouponType === 2) {
              this.$refs.yhtitle.innerHTML = this.formInline.discount + '元满减券，满' + this.formInline.usingThreshold + '元使用'
              this.$refs.syms1.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
            }
          }
        }
      } else {
        if (this.formInline.threshold == 1) {
          if (this.formInline.ticketType != 1 && this.formInline.ticketType != 2) {
            if (this.formInline.cashCouponType === 3) {
              this.$refs.yhtitle.innerHTML = this.formInline.discount + '折代金券，无门槛使用'
              this.$refs.syms1.innerHTML = '无使用门槛'
            }
          }
        } else {
          if (this.formInline.ticketType != 1 && this.formInline.ticketType != 2) {
            if (this.formInline.cashCouponType === 2) {
              this.$refs.yhtitle.innerHTML = this.formInline.discount + '折代金券，满' + this.formInline.usingThreshold + '元使用'
              this.$refs.syms1.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
            }
          }
        }
      }
    },
    'formInline.cashCouponType' (newVal, oldVal) {
      if (newVal == 2) {
        if (this.formInline.threshold == 1) {
          this.$nextTick(() => {
            this.$refs.yhtitle.innerHTML = this.formInline.discount + '元满减券，无门槛使用'
            this.$refs.syms1.innerHTML = '无使用门槛'
          })
        } else {
          this.$nextTick(() => {
            this.$refs.yhtitle.innerHTML = this.formInline.discount + '元满减券，满' + this.formInline.usingThreshold + '元使用'
            this.$refs.syms1.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
          })
        }
      } else if (newVal == 3) {
        if (this.formInline.threshold == 1) {
          this.$nextTick(() => {
            this.$refs.yhtitle.innerHTML = this.formInline.discount + '折代金券，无门槛使用'
            this.$refs.syms1.innerHTML = '无使用门槛'
          })
        } else {
          this.$nextTick(() => {
            this.$refs.yhtitle.innerHTML = this.formInline.discount + '折代金券，满' + this.formInline.usingThreshold + '元使用'
            this.$refs.syms1.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
          })
        }
      } else {
        this.$nextTick(() => {
          this.$refs.yhtitle.innerHTML = this.formInline.discountStart + '-' + this.formInline.discountEnd + '元代金券'
        })
      }
    },
  },
  methods: {
    ...mapMutations(['EXCHANGE_SELECTED']),
    // 处理最终的产品列表
    handleProductList (list) {
      this.choosedProductList = list
    },

    // 处理已经选择的产品
    handleChoosedProduct () {
      const { multipleSelectionAll: list } = this.$store.state
      this.$nextTick(() => {
        this.choosedProductList = list
      })
      // 关闭弹窗
      this.productDialog = false
    },

    // 关闭弹窗
    handleCloseDialog () {
      this.productDialog = false
    },

    // 打开弹窗
    handleOpenDialog () {
      this.productDialog = true
    },

    leave () {
      document.getElementById('cashCoupon_ts').style.display = 'none'
    },
    enter () {
      document.getElementById('cashCoupon_ts').style.display = 'block'
    },
    //搜索时查询产品名称
    remoteProductMethod (query) {
      if (query !== '') {
        let data = {
          page: 1,
          limit: 10,
          value: query,
          ticketTemplateId: ''
        }
        if (this.$route.query.id) {
          data.ticketTemplateId = this.$route.query.id
        }
        getProductList(data).then(res => {
          if (res.data.code == '200') {
            let result = res.data.result.list
            this.productRelationArray = result
            for (let i = 0; i < result.length; i++) {
              this.clickRelationArray.push(result[i])
            }
          }
        })
      } else {
        //					this.productRelationArray = []
      }

    },
    //点击时查询产品名称
    getMyProductOptions () {
      let data = {
        page: 1,
        limit: 10,
        value: '',
        ticketTemplateId: ''
      }
      if (this.$route.query.id) {
        data.ticketTemplateId = this.$route.query.id
      }
      getProductList(data).then(res => {
        if (res.data.code == '200') {
          let result = res.data.result.list
          this.productRelationArray = result
          // console.log(this.productRelationArray)
          for (let i = 0; i < result.length; i++) {
            this.clickRelationArray.push(result[i])
          }
        }
      })
    },
    changeProduct (value) {
      for (let i of value) {
        for (let item of this.productRelationArray) {
          if (i === item.productCode) {
            this.qzarr.push({
              code: i,
              name: item.productName
            })
          }
        }
      }
    },
    descInput (type) {
      if (type == 'name') {
        let ticketName = this.formInline.ticketName.length
        this.ticketName = this.ticketNameLength - ticketName
      } else if (type == 'conent') {
        let discountContent = this.formdiscountContent.length
        this.discountContent = 200 - discountContent
      } else {
        let txtVal = this.formInlineuseExplain.length
        this.remnant = 500 - txtVal
      }
    },
    discountChange () {
      this.formInline.discount = this.formInline.discount.replace(/[^\d.]/g, '')
    },
    thresholdChange () {
      this.formInline.usingThreshold = this.formInline.usingThreshold.replace(/[^\d.]/g, '')
    },
    cashCouponChange () {
      if (this.formInline.cashCouponType == 2) {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '元代金券，无门槛使用'
        } else {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '元代金券，满' + this.formInline.usingThreshold + '元使用'
        }
      } else if (this.formInline.cashCouponType == 3) {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '折代金券，无门槛使用'
        } else {
          this.$refs.yhtitle.innerHTML = this.formInline.discount + '折代金券，满' + this.formInline.usingThreshold + '元使用'
        }
      }
    },
    // thresholdChange () {
    //   this.formInline.usingThreshold = ''
    // },
    //模板详情
    getData () {
      this.dataList.id = this.$route.query.id
      cardList(this.dataList).then(res => {
        console.log(res)
        let result = res.data.result.list
        // 兑换的产品
        this.formInline.commoditys = result[0].commodity
        const { commodity = '' } = result[0] || {}
        // 转成数组
        const commodityList = JSON.parse(commodity) || []
        if (commodityList.length != 0) {
          // // 转成数组
          // const commodityList = JSON.parse(commodity)

          // 遍历后端返回的数组  返回一个新数组，替换了原数组的键名
          const newCommodityList = commodityList.map(item => {
            return {
              productCode: item.code,
              productName: item.name
            }
          })

          // 赋给已经选择的产品列表 
          this.choosedProductList = newCommodityList

          // 在vuex中存一下已经选择的产品列表
          this.EXCHANGE_SELECTED(this.choosedProductList)

          // 让 指定产品按钮处于选中状态
          this.productionRadio = PRODUCT_RADIO['appoint']
        } else {
          // 让 全部产品按钮处于选中状态
          this.productionRadio = PRODUCT_RADIO['all']

          // 当全部产品时
          this.choosedProductList = []
          this.EXCHANGE_SELECTED(this.choosedProductList)
        }
        this.formInline.id = result[0].id
        // 判断卡券的类型,等于1的时候将使用说明的换行进行展示
        this.formInline.ticketType = result[0].ticketType
        if (this.formInline.ticketType == 1 || this.formInline.ticketType == 2) {
          this.$refs.yhtitle.innerHTML = result[0].discountContent.replace(/\n/g, '<br>')
          this.formInline.discountContent = result[0].discountContent
        } else if (this.formInline.ticketType == 3) {
          this.$refs.yhtitle.innerHTML = result[0].discountContent
        }
        // 卡券名称
        this.formInline.ticketName = result[0].ticketName
        // 卡券名称效验
        this.ticketName = this.ticketNameLength - this.formInline.ticketName.length
        this.formInline.isPeriodValidity = result[0].isPeriodValidity
        // 判断有效期的形式
        if (this.formInline.isPeriodValidity == 1) {
          this.radio = 1
          let str = result[0].startTimeStr + ',' + result[0].endTimeStr
          this.validityDate = str.split(',')
          this.formInline.startTimeStr = this.validityDate[0].slice(0, 16)
          this.formInline.endTimeStr = this.validityDate[1].slice(0, 16)
        } else if (this.formInline.isPeriodValidity == 0) {
          this.radio = 0
          this.formInline.receiveLimitDay = result[0].receiveLimitDay
          this.formInline.startTimeStr = ''
          this.formInline.endTimeStr = ''
        } else {
          this.radio = 2
          this.formInline.startTimeStr = ''
          this.formInline.endTimeStr = ''
          this.formInline.receiveLimitDay = ''
        }
        this.formInline.cashCouponType = result[0].cashCouponType
        this.formInline.discount = result[0].discount
        if (result[0].usingThreshold != '' && result[0].usingThreshold != null) {
          this.formInline.usingThreshold = result[0].usingThreshold.toString()
          this.formInline.threshold = 2
        }
        console.log(this.formInline.usingThreshold)
        // 优惠内容
        this.formdiscountContent = result[0].discountContent
        if (result[0].discountEnd === '' || result[0].discountStart === 0) {
          this.discountStart = ''
          this.discountEnd = ''
        } else {
          this.discountStart = result[0].discountStart
          this.discountEnd = result[0].discountEnd
        }
        // 优惠内容字数校验
        this.discountContent = 200 - this.formdiscountContent.length
        // 将优惠内容中的换行进行显示
        this.$refs.yhContent.innerHTML = result[0].useExplain.replace(/\n/g, '<br>')
        // 使用说明的字数效验
        this.formInlineuseExplain = result[0].useExplain
        this.remnant = 500 - this.formInlineuseExplain.length
        // 核销操作的受众群组
        result[0].relateAudience = JSON.parse(result[0].relateAudience)
        this.formInline.relateAudienceObject.modelId = result[0].relateAudience.modelId
        if (result[0].relateAudience.groupIds !== undefined) {
          this.qzValue = result[0].relateAudience.groupIds
          this.qzParams.groupIds = result[0].relateAudience.groupIds
        }
        this.getQZList()
      })
    },
    getSzList () {
      getModelList().then(res => {
        this.szOptions = res.data.result
      })
    },
    szChange (val) {
      if (val == '') {
        this.qzValue = []
      }
      // else {
      this.qzOptions = []
      this.qzParams.modelId = val
      this.qzParams.groupId = ''
      this.getQZList()
      // }
    },
    getQZList () {
      getModelGroupList(this.qzParams).then(res => {
        this.qzOptions = res.data.result
      })
    },
    //增加受众
    addAnalyseDimension () {
      this.hxList.push({
        activityType: '',
        qzType: ''
      })
    },
    //删除受众
    removeDimensionItem (two, j) {
      // if (this.hxList.length === 1) {
      //   return
      // }
      this.hxList.splice(j, 1)
    },

    radioChange (val) {
      this.formInline.isPeriodValidity = val
      if (val == 1) {
        this.formInline.receiveLimitDay = ''
      } else if (val == 0) {
        this.formInline.startTimeStr = ''
        this.formInline.endTimeStr = ''
      } else {
        this.formInline.receiveLimitDay = ''
        this.formInline.startTimeStr = ''
        this.formInline.endTimeStr = ''
      }
    },
    dateTimeChange () {
      if (this.validityDate != undefined || this.validityDate != '') {
        this.formInline.startTimeStr = this.validityDate[0]
        this.formInline.endTimeStr = this.validityDate[1]
      }
    },
    //编辑卡券模板
    editTemplate () {
      if (this.formInline.cashCouponType == 3) {
        if (this.formInline.discount > 10 || this.formInline.discount < 0) {
          this.$message.error('优惠内容必须介于0到10之间！')
          return
        }
        if (!/^\d+(\.\d{1,1})?$/.test(this.formInline.discount)) {
          this.$message.error('优惠内容最多输入一位小数！')
          return
        }
      }

      if (this.formInline.startTimeStr !== '' && this.formInline.endTimeStr !== '') {
        this.formInline.startTimeStr = this.formInline.startTimeStr + ':00'
        this.formInline.endTimeStr = this.formInline.endTimeStr + ':00'
      }
      if (this.qzValue != '') {
        this.formInline.relateAudienceObject.groupIds = this.qzValue
      }
      if (this.formInline.threshold == 1) {
        this.formInline.usingThreshold = ''
      }
      // if (this.formInline.commoditys != '' && this.productId != '') {
      //   this.formInline.commoditys = JSON.parse(this.formInline.commoditys)
      //   if (this.qzarr.length !== 0) {
      //     this.formInline.commoditys = this.qzarr
      //   }

      // } else if (this.productId == '') {
      //   this.formInline.commoditys = [{
      //     code: '',
      //     name: ''
      //   }]
      // }
      // 判断一下 选择的是指定产品还是全部产品
      let product = []
      // 选择指定产品
      if (this.productionRadio === PRODUCT_RADIO['appoint']) {
        // 只选择了指定产品  但是没有选产品  要做一下判断
        if (this.choosedProductList.length === 0) {
          this.$message({
            message: '请选择指定产品',
            type: 'warning'
          })
          return
        }
        // 过滤 choosedProductList 只要以下三个字段
        product = this.choosedProductList.map(item => {
          return {
            name: item.productName,
            code: item.productCode
          }
        })

      }
      this.formInline.commoditys = product
      editTemplate(this.formInline).then(res => {
        if (res.data.code == 200) {
          _g.toastMsg('success', '保存成功')
          router.push('/home/card-ticket-module')
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    }
  },
  mounted () {
    this.getData()
    //获取受众列表
    this.getSzList()
    this.getMyProductOptions()
  }
}
</script>

<style scoped>
.card-hxSelect {
  margin-bottom: 10px;
}
</style>